import * as v from "valibot";

export const WEBSITE_TABS = ["overview", "urls", "entries", "runs"] as const;

export type WebsiteTab = (typeof WEBSITE_TABS)[number];

export const DEFAULT_WEBSITE_TAB: WebsiteTab = "overview";

export const searchParams = v.object({
  tab: v.optional(v.picklist(WEBSITE_TABS)),
});

export type SourcingWebsiteSearch = v.InferOutput<typeof searchParams>;
